import moment from "moment";

// Décorateurs
import { OmitField } from 'src/app/@shared/decorators/api-field.decorator';

// Modèles
import { ModelBase } from '../../abstract/model-base.model';
import { BankStatement } from './bank-statement.model';
import { Currency } from '../../core/currency.model';

export class BankStatementLine extends ModelBase {

    static override CLASS_NAME: string = 'BankStatementLine';

    /*----------------------------------------------------------------------------------------
     * Propriétés
     ----------------------------------------------------------------------------------------*/

    private _amount!: number;
    private _amountSigned!: number;
    private _bankAccountLineId!: number;
    private _bankStatement!: BankStatement;
    private _credit!: number;
    private _creditBac!: number;
    private _currency!: Currency;
    private _debit!: number;
    private _debitBac!: number;
    private _operationNature!: string;
    private _transactionDate!: moment.Moment;
    private _valueDate!: moment.Moment;

    /*----------------------------------------------------------------------------------------
     * Accesseurs
     ----------------------------------------------------------------------------------------*/

    public get amount(): number {
        return this._amount;
    }

    public set amount(value: any) {
        this._setValue('_amount', value, 'float');
    }

    /**
     * Retourne le montant formaté avec la devise
     */
    public get amountFormatted(): string {
        return `${this._amountSigned.toLocaleString()} ${this._currency?.code || ''}`;
    }

    public get amountSigned(): number {
        return this._amountSigned;
    }

    @OmitField()
    public set amountSigned(value: any) {
        this._setValue('_amountSigned', value, 'float');
    }

    public get bankAccountLineId(): number {
        return this._bankAccountLineId;
    }

    public set bankAccountLineId(value: any) {
        this._setValue('_bankAccountLineId', value, 'integer');
    }

    public get bankStatement(): BankStatement {
        return this._bankStatement;
    }

    @OmitField()
    public set bankStatement(value: any) {
        this._setValue('_bankStatement', value, 'BankStatement');
    }

    public get credit(): number {
        return this._credit;
    }

    public set credit(value: any) {
        this._setValue('_credit', value, 'float');
    }

    public get creditBac(): number {
        return this._creditBac;
    }

    @OmitField()
    public set creditBac(value: any) {
        this._setValue('_creditBac', value, 'float');
    }

    public get currency(): Currency {
        return this._currency;
    }

    public set currency(value: any) {
        this._setValue('_currency', value, 'Currency');
    }

    public get debit(): number {
        return this._debit;
    }

    public set debit(value: any) {
        this._setValue('_debit', value, 'float');
    }

    public get debitBac(): number {
        return this._debitBac;
    }

    public set debitBac(value: any) {
        this._setValue('_debitBac', value, 'float');
    }

    /**
     * Retourne true si la ligne est un crédit
     */
    public get isCredit(): boolean {
        return this._credit > 0;
    }

    /**
     * Retourne true si la ligne est un débit
     */
    public get isDebit(): boolean {
        return this._debit > 0;
    }

    public get operationNature(): string {
        return this._operationNature;
    }

    public set operationNature(value: any) {
        this._setValue('_operationNature', value, 'string');
    }

    public get transactionDate(): moment.Moment {
        return this._transactionDate;
    }

    public set transactionDate(value: any) {
        this._setValue('_transactionDate', value, 'date');
    }

    public get valueDate(): moment.Moment {
        return this._valueDate;
    }

    public set valueDate(value: any) {
        this._setValue('_valueDate', value, 'date');
    }

    /*----------------------------------------------------------------------------------------
     * Méthodes publiques
     ----------------------------------------------------------------------------------------*/

    /**
     * Retourne la classe CSS pour le montant selon son signe
     */
    public getAmountClass(): string {
        if (this._amountSigned > 0) {
            return 'text-green-500';
        } else if (this._amountSigned < 0) {
            return 'text-red-500';
        } else {
            return '';
        }
    }

    /*----------------------------------------------------------------------------------------
     * Méthodes protégées
     ----------------------------------------------------------------------------------------*/

    /*----------------------------------------------------------------------------------------
     * Méthodes privées
     ----------------------------------------------------------------------------------------*/
}